/*
 *
 * ErrorBoundary
 *
 * this component make react errors more readable
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: '', errorInfo: '', isChunkLoadError: false }
  }

  componentDidCatch (error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo)

    this.setState({
      hasError: true,
      error,
      errorInfo
    })
  }

  componentDidUpdate () {
    const { hasError, error } = this.state

    // Se non c'è errore → niente
    if (!hasError) return

    if (error && error.toString().includes('ChunkLoadError')) {
      // evita loop infiniti
      if (!window.__chunkReloadTriggered) {
        window.__chunkReloadTriggered = true
        this.setState({ isChunkLoadError: true })
        window.location.reload()
      }
    }
  }

  render () {
    const { hasError, error, errorInfo, isChunkLoadError } = this.state

    // Se abbiamo un errore e vogliamo mostrarlo (ERROR_BOUNDARY_ON = true)
    if (hasError && !isChunkLoadError) {
      return (
        <div className='bigbody'>
          <div className='errorbody'>
            <h2 data-testid='errorboundary'>Something went wrong.</h2>
            <br />
            <span>Here&apos;s the error: {error.toString()}</span>
            <details className='detailsbutton'>
              {errorInfo ? errorInfo.componentStack : <h3>Sorry, no more details</h3>}
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element
}

ErrorBoundary.defaultProps = {
  children: React.createElement('div')
}

export default ErrorBoundary
